module.exports = __webpack_public_path__ + "static/media/strokewidth.346e73bc.svg";